// Informations LÉGALES de l'éditeur — le seul fichier à compléter.
//
// Toutes les pages légales (mentions, confidentialité, cookies, conditions,
// sous-traitance, sécurité) lisent ces valeurs. Une valeur entre crochets
// « [ … ] » est un emplacement À COMPLÉTER : elle s'affiche surlignée, et un
// bandeau signale la page comme incomplète tant qu'il en reste une. Rien ne
// doit partir en bêta publique avec un crochet.
//
// Ces textes sont des BROUILLONS rédigés pour Zygosight tel qu'il est
// construit (hébergement, cookies, IA, sous-traitants réels). Ils doivent être
// relus par un juriste avant publication.

/** Même valeur que `TERMS_VERSION` côté serveur (`server/src/legal/terms.js`). */
export const TERMS_VERSION = '2026-09-25';
export const UPDATED_ON = '25 septembre 2026';

export const EDITOR = {
  name: 'Frédéric Rossi',
  legalForm: 'Entrepreneur individuel',
  capital: 'Sans objet (entrepreneur individuel)',
  address: '64 rue du Repos, 69007 Lyon, France',
  registration: 'SIRET 539 660 688 00026 — code APE 74.10Z',
  vat: '[N° de TVA intracommunautaire, le cas échéant]',
  phone: '[Téléphone]',
  email: 'hello@fredericrossi.com',
  publicationDirector: 'Frédéric Rossi',
};

/** Adresse pour exercer ses droits RGPD, et pour signaler une faille. */
export const PRIVACY_CONTACT = 'hello@fredericrossi.com';
export const SECURITY_CONTACT = 'hello@fredericrossi.com';

/** Hébergeurs, au sens de la LCEN (art. 6 III). */
export const HOSTS = [
  {
    name: 'Google Cloud EMEA Limited',
    role: 'Hébergement de l’application (Cloud Run), des enregistrements (Cloud Storage) et traitements d’IA (Vertex AI)',
    address: '70 Sir John Rogerson’s Quay, Dublin 2, Irlande [à vérifier sur votre contrat Google Cloud]',
    phone: '[Téléphone de l’hébergeur]',
    location: 'Région europe-west1 (Saint-Ghislain, Belgique)',
  },
  {
    name: 'Supabase, Inc.',
    role: 'Hébergement de la base de données',
    address: '[Adresse de Supabase, Inc. — voir votre contrat ou le DPA Supabase]',
    phone: '[Téléphone de l’hébergeur]',
    location: 'Francfort (Allemagne), infrastructure Amazon Web Services eu-central-1',
  },
];

/** Sous-traitants ultérieurs (art. 28 RGPD) : QUI traite QUOI, OÙ. */
export const SUBPROCESSORS = [
  {
    name: 'Google Cloud (Cloud Run, Cloud Logging)',
    purpose: 'Exécution de l’application, journaux techniques',
    location: 'Union européenne (Belgique)',
  },
  {
    name: 'Google Cloud (Cloud Storage)',
    purpose: 'Stockage des enregistrements audio et vidéo d’entretiens',
    location: 'Union européenne (Belgique)',
  },
  {
    name: 'Google Cloud (Vertex AI — modèles Gemini)',
    purpose: 'Transcription des entretiens, extraction de verbatims, synthèses et propositions assistées par IA',
    location: 'Union européenne (Belgique)',
  },
  {
    name: 'Supabase',
    purpose: 'Base de données (comptes, projets, données de recherche)',
    location: 'Union européenne (Allemagne)',
  },
];

/** Médiation de la consommation (art. L612-1 du Code de la consommation), si
 *  des consommateurs utilisent le service. */
export const MEDIATOR = '[Nom et coordonnées du médiateur de la consommation, si le service s’adresse à des consommateurs]';

export const isPlaceholder = (v: string) => /\[[^\]]+\]/.test(v);

/** Reste-t-il des emplacements à compléter ? */
export function hasPlaceholders(): boolean {
  const values = [
    ...Object.values(EDITOR),
    ...HOSTS.flatMap((h) => Object.values(h)),
    MEDIATOR,
  ];
  return values.some((v) => isPlaceholder(String(v)));
}
